//copied from VPC
import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DetailsTooltipStyles } from '../DetailsTooltipStyles';

export interface TagsProps {
  tags?: string[];
}

export const Tags = (props: TagsProps) => {
  return props.tags && props.tags.length > 0 ? (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span>{Messages.tags()}</span>
      <span className={DetailsTooltipStyles.MetadataValue}>{props.tags.join(', ')}</span>
    </div>
  ) : null;
};
